<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <side-bar
      :background-color="sidebarBackground"
      short-title="Startup"
      title="Dashboard Administrador"
      :displaySidebar="displaySidebar"
    >
      <template v-if="hasPitchDeck" slot="links">
        <!-- menu links -->
        <sidebar-item
          v-for="link in menu.links"
          :key="link.path"
          :link="link"
        />
      </template>
      <template v-else slot="links">
        <sidebar-item
          v-for="link in menu.links.filter(
            (link) => link.name == 'Suporte' || link.name == 'Edital'
          )"
          :key="link.path"
          :link="link"
        />
      </template>
    </side-bar>
    <div class="main-content" :data="sidebarBackground">
      <i
        class="fa fa-bars btn-toggle d-none d-md-block"
        @click="toggleDisplaySidebar()"
      ></i>
      <dashboard-navbar :name="startup.name"></dashboard-navbar>
      <div @click="toggleSidebar">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
      </div>
    </div>
    <content-footer
      v-if="!$route.meta.hideFooter"
      :showSocial="displaySidebar && hasPitchDeck"
    ></content-footer>
    <!-- nova versão do InitialInfoModal para inscrições a partir de 07/2023 -->
    <initial-info-modal-v2 v-on:startup_name="handleStartupName($event)" />
  </div>
</template>
<script>
import DashboardNavbar from "./../DashboardNavbar.vue";
import ContentFooter from "./../ContentFooter.vue";
import { FadeTransition } from "vue2-transitions";
import InitialInfoModalV2 from "@/views/Startup/Dashboard/InitialInfoModal_v2";
import api from "@/services/api";

import menu from "./menu.json";

export default {
  name: "dashboard-startup",
  components: {
    DashboardNavbar,
    ContentFooter,
    FadeTransition,
    InitialInfoModalV2,
  },
  data() {
    return {
      startup: {
        name: "",
      },
      sidebarBackground: "vue", //vue|blue|orange|green|red|primary
      menu: menu,
      displaySidebar: true,
      hasPitchDeck: false,
    };
  },
  mounted() {
    this.checkPitchDeck();
  },
  methods: {
    handleStartupName(e) {
      this.startup.name = e;
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    toggleDisplaySidebar() {
      this.displaySidebar = !this.displaySidebar;
    },
    async checkPitchDeck() {
      try {
        let subscriptionId = this.$route.params.id;

        if (!subscriptionId) {
          const { data } = await api.get("/startup-call-subscriptions/");
          if (!data || !data.length) {
            this.hasPitchDeck = false;
            return;
          }
          subscriptionId = data[0].id;
        }

        const { data: startup } = await api.get(
          `/startup-call-subscriptions/${subscriptionId}`
        );

        this.hasPitchDeck =
          !!startup.subscription &&
          !!startup.subscription.deck &&
          !!startup.subscription.deck.url;
      } catch (e) {
        this.hasPitchDeck = false;
      }
    },
  },
};
</script>
